import type { ReactElement } from "react";

import { memberUrls } from "../../app/member-urls.js";

/**
 * お支払いが止まっている印（<c>GET /api/tenants/{契約}</c> の <c>contract.paymentPaused</c>。サーバの PausedPaymentView と同じ欄）。
 * <b>カード払いの契約の契約者にだけ、定期課金が止まっているときにサーバが付ける</b>（Implem.Portal.Backend の docs/features/10 §1-3）。
 */
export interface PausedPayment {
    /** 印の文言（「お支払いが止まっています」）。 */
    readonly label: string;
    /** 印に添える案内。 */
    readonly notice: string;
    /** 「カード情報の変更」から再開できるか。false なら、ボタンの代わりにお問い合わせへ案内する（1 か月を超えた・運営が止めたものなど）。 */
    readonly canResume: boolean;
}

/** お支払いが止まっている印と案内。<b>出すか・文言・ボタンの先はサーバの欄で決める</b>（画面で判定しない）。 */
export function PausedPaymentNotice(
    { paused, tenantId }: { readonly paused: PausedPayment; readonly tenantId: number },
): ReactElement {
    return (
        <div className="alert-warning mb-6" role="status" data-payment-paused="">
            <p className="mb-2"><span className="badge-warning">{paused.label}</span></p>
            <p className="mb-3">{paused.notice}</p>
            {paused.canResume
                ? <a className="btn-secondary btn-sm" href={memberUrls.changeCard(tenantId)}>カード情報の変更</a>
                : <a className="btn-secondary btn-sm" href="/Home/Contact">お問い合わせ</a>}
        </div>
    );
}
